var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 23.3332C33.155 23.3332 37.3337 19.1545 37.3337 13.9998C37.3337 8.84518 33.155 4.6665 28.0003 4.6665C22.8457 4.6665 18.667 8.84518 18.667 13.9998C18.667 19.1545 22.8457 23.3332 28.0003 23.3332Z",
    stroke: "#354764",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 20.9997C45.8663 20.9997 49 18.3863 49 15.1663C49 11.9463 45.8663 9.33301 42 9.33301M14 20.9997C10.1337 20.9997 7 18.3863 7 15.1663C7 11.9463 10.1337 9.33301 14 9.33301",
    stroke: "#354764",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48.9997C35.732 48.9997 42 44.821 42 39.6663C42 34.5117 35.732 30.333 28 30.333C20.268 30.333 14 34.5117 14 39.6663C14 44.821 20.268 48.9997 28 48.9997Z",
    stroke: "#354764",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6668 44.3332C50.7595 43.4348 53.6668 41.1622 53.6668 38.4998C53.6668 35.8375 50.7595 33.5648 46.6668 32.6665M9.3335 44.3332C5.24083 43.4348 2.3335 41.1622 2.3335 38.4998C2.3335 35.8375 5.24083 33.5648 9.3335 32.6665",
    stroke: "#354764",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHz);
export default __webpack_public_path__ + "static/media/icon-hz.b729fa2ab73c4cbe50f679520ee609fb.svg";
export { ForwardRef as ReactComponent };